export default {
  name: 'account--companySettings',
  apiService: 'shoes',
  apiPath: '/admin/company_shoes_info',
};